module.exports = __webpack_public_path__ + "img/17.2ef2b946.gif";